/* eslint-disable @typescript-eslint/consistent-type-assertions */
import { ExternalLink } from "@octopusdeploy/design-system-components";
import type { GoogleContainerRegistryFeedResource, FeedResource, OidcFeedAuthentication } from "@octopusdeploy/octopus-server-client";
import { FeedType } from "@octopusdeploy/octopus-server-client";
import * as React from "react";
import RetryAttemptsFormSection from "~/areas/library/components/ExternalFeeds/RetryAttemptsFormSection";
import AdvancedFeedCredentialsFormSection, { AuthenticationType } from "../AdvancedFeedCredentialsFormSection";
import type { FeedEditProps } from "./feedTypeRegistry";
import feedTypeRegistry from "./feedTypeRegistry";
const googleAuthUsername: string = "_json_key";
class GoogleRegistryContainerFeed extends React.Component<FeedEditProps<GoogleContainerRegistryFeedResource>> {
    render() {
        return (<React.Fragment>
                <RetryAttemptsFormSection backoffSeconds={this.props.feed.DownloadRetryBackoffSeconds} onBackoffSecondsChanged={(seconds) => this.props.onChange({ ...this.props.feed, DownloadRetryBackoffSeconds: seconds })} attemptCount={this.props.feed.DownloadAttempts} onAttemptCountChanged={(count) => this.props.onChange({ ...this.props.feed, DownloadAttempts: count })} containerKey={this.props.expandableContainerKey}/>
                <AdvancedFeedCredentialsFormSection model={{ username: this.props.feed.Username, password: this.props.feed.Password }} isNew={!this.props.feed.Id} authenticationType={this.getAuthType(this.props.feed)} oidcModel={this.props.feed.OidcAuthentication} onChanged={(model, oidcModel) => {
                this.updateAuthentication({
                    OidcAuthentication: oidcModel,
                    Username: googleAuthUsername,
                    Password: model.password ?? { HasValue: false },
                });
            }} supportedAuthenticationTypes={[AuthenticationType.GoogleCloudJsonKey, AuthenticationType.Oidc]} containerKey={this.props.expandableContainerKey}/>
            </React.Fragment>);
    }
    private getAuthType = (feed: GoogleContainerRegistryFeedResource): AuthenticationType => {
        if (feed.Password?.HasValue)
            return AuthenticationType.GoogleCloudJsonKey;
        if (feed.OidcAuthentication)
            return AuthenticationType.Oidc;
        return AuthenticationType.GoogleCloudJsonKey;
    };
    private updateAuthentication = (updatedFields: Partial<GoogleContainerRegistryFeedResource>) => {
        const existingAuthDetails = this.props.feed;
        const updatedOidcAuthentication: OidcFeedAuthentication = {
            Audience: updatedFields.OidcAuthentication?.Audience ?? existingAuthDetails.OidcAuthentication?.Audience ?? "",
            SubjectKeys: updatedFields.OidcAuthentication?.SubjectKeys ?? existingAuthDetails.OidcAuthentication?.SubjectKeys ?? [],
        };
        this.props.onChange({ ...this.props.feed, Username: updatedFields.Username, Password: updatedFields.Password, OidcAuthentication: updatedOidcAuthentication });
    };
    static displayName = "GoogleRegistryContainerFeed";
}
feedTypeRegistry.registerFeedType({
    type: FeedType.GoogleContainerRegistry,
    edit: GoogleRegistryContainerFeed as React.ComponentType<FeedEditProps<FeedResource>>,
    text: "Google Container Registry",
    uriNotes: (<React.Fragment>
            <div>
                See Google Contaner Registry <ExternalLink href="GCRRegistryLinks">documentation</ExternalLink>.
                <br />
                Configure an <ExternalLink href="btwJZI">Google Contaner Registry</ExternalLink> in Octopus.
            </div>
        </React.Fragment>),
    uriDefault: "https://gcr.io",
});
